import React from "react";
import { Spin } from "antd";
import {
  TbSquareRoundedCheck,
  TbSquareRoundedCheckFilled,
} from "react-icons/tb";

interface UiCheckBoxComponentProps {
  loading: boolean;
  isChecked: boolean;
  onChange?: (checked: boolean) => void;
  key?: any;
  index: any;
}

const UiCheckBoxComponent: React.FC<UiCheckBoxComponentProps> = ({
  loading,
  isChecked,
  onChange,
}) => {
  const onClick = () => {
    if (!loading && onChange) {
      onChange(!isChecked);
    }
  };

  return (
    <div
      className={`access-rights-check${isChecked ? " is-on" : ""}${
        loading ? " is-loading" : ""
      }`}
      onClick={onClick}
      role="button"
      aria-pressed={isChecked}
      aria-busy={loading}
    >
      {loading ? (
        <Spin size="small" />
      ) : isChecked ? (
        <TbSquareRoundedCheckFilled size={22} />
      ) : (
        <TbSquareRoundedCheck size={22} />
      )}
    </div>
  );
};

export default UiCheckBoxComponent;
